module.exports = __webpack_public_path__ + "img/cancelIconUS.c4ddf1a5.png";